import { render } from "./UserOKPrivateModal.vue?vue&type=template&id=50762700&scoped=true"
import script from "./UserOKPrivateModal.vue?vue&type=script&lang=js"
export * from "./UserOKPrivateModal.vue?vue&type=script&lang=js"

import "./UserOKPrivateModal.vue?vue&type=style&index=0&id=50762700&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50762700"]])

export default __exports__